export function calculateShiftSalary({
  startTime,
  endTime,
  hourlyWage,
  transportationFee = 0,
}) {
  return (
    calculateShiftWage({
      startTime,
      endTime,
      hourlyWage,
    }) + (Number(transportationFee) || 0)
  );
}

export function calculateShiftWage({
  startTime,
  endTime,
  hourlyWage,
}) {
  if (!startTime || !endTime) return 0;

  const wage = Number(hourlyWage) || 0;
  const parseMinutes = (time) => {
    const [hours, minutes] = String(time).split(":").map(Number);
    if (
      Number.isNaN(hours) ||
      Number.isNaN(minutes)
    ) {
      return null;
    }
    return hours * 60 + minutes;
  };

  const startMinutes = parseMinutes(startTime);
  const endMinutes = parseMinutes(endTime);

  if (startMinutes === null || endMinutes === null) {
    return 0;
  }

  const totalMinutes = endMinutes <= startMinutes
    ? endMinutes + 24 * 60 - startMinutes
    : endMinutes - startMinutes;

  let regularMinutes = 0;
  let nightMinutes = 0;
  let overtimeMinutes = 0;
  let nightOvertimeMinutes = 0;
  let workedMinutes = 0;

  for (let offset = 0; offset < totalMinutes; offset += 1) {
    const minuteOfDay = (startMinutes + offset) % (24 * 60);
    const hour = Math.floor(minuteOfDay / 60);
    const isNight = hour >= 22 || hour < 5;
    const isOvertime = workedMinutes >= 480;

    if (isNight && isOvertime) {
      nightOvertimeMinutes += 1;
    } else if (isNight) {
      nightMinutes += 1;
    } else if (isOvertime) {
      overtimeMinutes += 1;
    } else {
      regularMinutes += 1;
    }

    workedMinutes += 1;
  }

  return (
    (regularMinutes / 60) * wage +
    (nightMinutes / 60) * wage * 1.25 +
    (overtimeMinutes / 60) * wage * 1.25 +
    (nightOvertimeMinutes / 60) * wage * 1.5
  );
}

export function calculateShiftSalaryTotal({
  shifts,
  hourlyWage,
  transportationFee = 0,
  transportationLimit = 10000,
}) {
  const wageTotal = shifts.reduce((total, shift) => (
    total + calculateShiftWage({
      startTime: shift.start_time,
      endTime: shift.end_time,
      hourlyWage,
    })
  ), 0);
  const transportationTotal =
    (Number(transportationFee) || 0) * shifts.length;

  return wageTotal + Math.min(transportationTotal, transportationLimit);
}
